import { FormControlLabel, Radio, TextField, Typography } from '@mui/material'
import React from 'react'
import { Controller, useFormContext, useWatch } from 'react-hook-form'

import { AuthenticationType } from 'components/status-checks/authentication-form-utils'
import { type StatusCheckFormValues } from 'components/status-checks/status-checks-form-utils'

export const ObservabilityToolAwsSecretsManagerAuthenticationOption = () => {
  const { control } = useFormContext<StatusCheckFormValues>()

  const [authenticationType] = useWatch<StatusCheckFormValues>({
    control,
    name: ['authenticationType']
  })

  return (
    <>
      <FormControlLabel
        control={
          <Radio data-testid="observability-tool-authentication-type-aws-secrets-manager" />
        }
        label={
          <Typography>Retrieve credentials from AWS Secrets manager</Typography>
        }
        value={AuthenticationType.AWSSecretsManager}
      />
      <Typography color="text.secondary" variant="caption">
        This AWS ARN should point to a secret in Secrets Manager. We retrieve
        the credentials at runtime when executing a health check.
      </Typography>
      {authenticationType === AuthenticationType.AWSSecretsManager && (
        <Controller
          control={control}
          name="secret"
          render={({ field, fieldState: { error } }) => (
            <TextField
              data-testid="observability-tool-authentication-aws-arn-input"
              {...field}
              required
              error={Boolean(error)}
              helperText={error?.message}
              label="AWS ARN"
              sx={{ mt: 2 }}
              variant="outlined"
            />
          )}
        />
      )}
    </>
  )
}
